import React from 'react';
import Navbar from '../common/Navbar';
import Footer from '../common/Footer';
import ContactUs from '../common/ContactUs';

const services = [
  { name: 'Convert iMessages to PDFs', proSlayPrice: '$300', traditionalPrice: '$2,100' },
  { name: 'Generate Affidavit', proSlayPrice: '$400', traditionalPrice: '$2,800' },
  { name: 'Auto-Create Subpoena', proSlayPrice: '$450', traditionalPrice: '$3,150' },
  { name: 'Pro Se Motion Kit', proSlayPrice: '$350', traditionalPrice: '$2,450' },
  { name: 'Emergency Court Order', proSlayPrice: '$600', traditionalPrice: '$4,200' },
  { name: 'Wage Garnishment Filing', proSlayPrice: '$700', traditionalPrice: '$4,900' },
  { name: 'Custom Legal Motion', proSlayPrice: '$700', traditionalPrice: '$4,900' },
  { name: '20-Page Legal Brief', proSlayPrice: '$800', traditionalPrice: '$5,600' },
  { name: 'Temporary Restraining Order', proSlayPrice: '$750', traditionalPrice: '$5,250' },
  { name: 'Respond to Complaint', proSlayPrice: '$650', traditionalPrice: '$4,550' },
  { name: 'Motion to Compel', proSlayPrice: '$600', traditionalPrice: '$4,200' },
  { name: 'Document Request (Discovery)', proSlayPrice: '$750', traditionalPrice: '$5,250' },
  { name: 'Deposition Support', proSlayPrice: '$800', traditionalPrice: '$5,600' },
  { name: 'Summary Judgment Filing', proSlayPrice: '$800', traditionalPrice: '$5,600' },
  { name: 'Court Hearing Preparation', proSlayPrice: '$700', traditionalPrice: '$4,900' },
  { name: 'Draft Counterclaim', proSlayPrice: '$750', traditionalPrice: '$5,250' },
  { name: 'File Notice of Appeal', proSlayPrice: '$800', traditionalPrice: '$5,600' },
  { name: 'Bankruptcy Filing', proSlayPrice: '$800', traditionalPrice: '$5,600' },
  { name: 'Fraudulent Filing Analysis', proSlayPrice: '$800', traditionalPrice: '$5,600' },
  { name: 'Class Action Setup', proSlayPrice: '$800', traditionalPrice: '$5,600' },
  { name: 'Proof of Service Documentation', proSlayPrice: '$300', traditionalPrice: '$2,100' },
  { name: 'Line-by-Line Filing Review', proSlayPrice: '$450', traditionalPrice: '$3,150' },
  { name: 'PACER Case Summary', proSlayPrice: '$700', traditionalPrice: '$4,900' },
  { name: 'Exhibit Binder Creation', proSlayPrice: '$500', traditionalPrice: '$3,500' },
  { name: 'Court Deadline Calendar', proSlayPrice: '$300', traditionalPrice: '$2,100' },
  { name: 'Pretrial Strategy Map', proSlayPrice: '$800', traditionalPrice: '$5,600' },
  { name: 'Motion for Sanctions', proSlayPrice: '$750', traditionalPrice: '$5,250' },
  { name: 'Default Judgment Filing', proSlayPrice: '$600', traditionalPrice: '$4,200' },
  { name: 'Judicial Misconduct Complaint', proSlayPrice: '$700', traditionalPrice: '$4,900' },
  { name: 'Same-Day Emergency Injunction', proSlayPrice: '$800', traditionalPrice: '$5,600' },
  { name: 'Digital Archive & Timestamping', proSlayPrice: '$500', traditionalPrice: '$3,500' },
];

const LegalServicesMenuPage = () => {
  return (
    <div style={{ fontFamily: 'Arial, sans-serif' }}>
    <Navbar/>
    <div className="container py-5 text-center">
      <h1 className="display-4 fw-bold py-5" id='main-font'>
        ProSlay À La Carte Legal Services Menu
      </h1>
      <div className="table-responsive">
        <table className="table table-striped border">
          <thead className="table-dark">
            <tr>
              <th id='main-font' className='text-dark'>Service</th>
              <th id='main-font' className='text-dark'>ProSlay Price</th>
              <th id='main-font' className='text-dark'>Traditional Firm Cost</th>
            </tr>
          </thead>
          <tbody>
            {services.map((item, index) => (
              <tr key={index}>
                <td>{item.name}</td>
                <td>{item.proSlayPrice}</td>
                <td>{item.traditionalPrice}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
    <ContactUs/>
    <Footer/>
    </div>
  );
};

export default LegalServicesMenuPage;
